import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      required: true
    },
      rules: {
          type: Array,
          default: []
      }
  },
  data() {
    return {
      signatureData: this.modelValue
    }
  },
  watch: {
    modelValue(newValue) {
      this.signatureData = newValue
      if (newValue && this.$refs.signaturePad) {
        this.$refs.signaturePad.fromDataURL(newValue)
      }
    }
  },
  mounted() {
    if (this.modelValue && this.$refs.signaturePad) {
      this.$refs.signaturePad.fromDataURL(this.modelValue)
    }
  },
  methods: {
    handleEnd() {
      const { data } = this.$refs.signaturePad.saveSignature()
      this.signatureData = data
      this.$emit('update:modelValue', data)
    },
    clear() {
      this.$refs.signaturePad.clearSignature()
      this.signatureData = ''
      this.$emit('update:modelValue', '')
    }
  }
})
